import Styles from './WorkflowBuilderItem.module.scss'

export const ConnectionLine = () => (
  <div className={Styles.connectionLine}>
    <svg width="7" height="6" viewBox="0 0 7 6" fill="none" className={Styles.arrow}>
      <path d="M4.21858 5.60377C3.89921 6.13208 3.10079 6.13207 2.78142 5.60377L0.112403 1.18868C-0.206967 0.660377 0.192246 4.99021e-07 0.830984 4.4569e-07L6.16902 0C6.80776 -5.33305e-08 7.20697 0.660377 6.8876 1.18868L4.21858 5.60377Z" />
    </svg>
    <div className={Styles.line} />
    <div className={Styles.dot} />
  </div>
)
